import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver went off duty.
 */
export const offDutyV1 = tmsEventKind(
  { category: "dutyStatus", kind: "offDuty", version: 1 },
  {
    refs: dutyStatusChangeRefs,
    facts: {
      /** Whether a second driver was signed in — a flag, never the co-driver's identity. */
      withCoDriver: z.boolean(),
    },
  },
);

export const OffDutyV1Schema = offDutyV1.schema;
export const OffDutyV1FactsSchema = offDutyV1.facts;

export type OffDutyV1 = z.infer<typeof OffDutyV1Schema>;
export type OffDutyV1Facts = z.infer<typeof OffDutyV1FactsSchema>;

/** Every version of `offDuty`, keyed by version. What `catalog.ts` places under `dutyStatus`. */
export const offDuty = { 1: offDutyV1 } as const;
